/**
 * Accessibility patches
 *
 * 1. Sets `inert` on elements with class `scroll-trigger--offscreen` so that
 *    axe-core skips hidden off-screen elements when checking color contrast.
 *    Removes `inert` once the class transitions to `scroll-trigger--animate`.
 *
 * 2. Adds aria-label attributes to Curator.io elements that are injected into
 *    the DOM after page load (span[role="button"].crt-play and
 *    span[role="link"].crt-social-icon).
 */

// ---------------------------------------------------------------------------
// 1. inert patch for scroll-trigger--offscreen elements
// ---------------------------------------------------------------------------
(function () {
  function applyInertState(el) {
    if (el.classList.contains('scroll-trigger--offscreen')) {
      el.inert = true;
    } else {
      el.inert = false;
    }
  }

  // Apply to all elements that already exist on page load.
  document.querySelectorAll('.scroll-trigger').forEach(applyInertState);

  // Watch for class attribute changes on existing scroll-trigger elements.
  var classObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        applyInertState(mutation.target);
      }
    });
  });

  function observeScrollTriggerElement(el) {
    classObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  document.querySelectorAll('.scroll-trigger').forEach(observeScrollTriggerElement);

  // Watch the DOM for newly added scroll-trigger elements (e.g. lazy sections).
  var domObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('scroll-trigger')) {
          applyInertState(node);
          observeScrollTriggerElement(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.scroll-trigger').forEach(function (el) {
            applyInertState(el);
            observeScrollTriggerElement(el);
          });
        }
      });
    });
  });

  domObserver.observe(document.body, { childList: true, subtree: true });
})();

// ---------------------------------------------------------------------------
// 2. Curator.io aria-label patch
// ---------------------------------------------------------------------------
(function () {
  function getPlatformLabel(el) {
    // Prefer a crt-icon-* class on the element itself.
    var iconClass = Array.from(el.classList).find(function (c) {
      return c.startsWith('crt-icon-');
    });
    if (iconClass) {
      var name = iconClass.replace('crt-icon-', '');
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    // Fall back to the crt-post-<platform> class on the ancestor article.
    var article = el.closest && el.closest('article[class*="crt-post-"]');
    if (article) {
      var platforms = ['instagram', 'twitter', 'facebook', 'tiktok', 'youtube', 'pinterest'];
      for (var i = 0; i < platforms.length; i++) {
        if (article.classList.contains('crt-post-' + platforms[i])) {
          return platforms[i].charAt(0).toUpperCase() + platforms[i].slice(1);
        }
      }
    }
    return 'social media';
  }

  // Curator actively removes aria-label via its own observer, but leaves title alone.
  // title is a valid accessible name source for aria-command-name (WCAG 4.1.2).
  function patchAll() {
    document.querySelectorAll('span.crt-social-icon:not([title])').forEach(function (el) {
      el.setAttribute('title', 'View on ' + getPlatformLabel(el));
    });
    document.querySelectorAll('span.crt-play:not([title])').forEach(function (el) {
      el.setAttribute('title', 'Play video');
    });
  }

  // Immediate pass for anything already in the DOM.
  patchAll();

  // Re-run on any DOM mutation (catches Curator's async feed rendering).
  new MutationObserver(function (mutations) {
    var hasAdditions = mutations.some(function (m) { return m.addedNodes.length > 0; });
    if (hasAdditions) patchAll();
  }).observe(document.body, { childList: true, subtree: true });

  // Delayed passes after full page load as a safety net.
  window.addEventListener('load', function () {
    [100, 500, 1500].forEach(function (delay) {
      setTimeout(patchAll, delay);
    });
  });
})();

// ---------------------------------------------------------------------------
// 3. Add .product-reviews--empty class to the section when Yotpo renders
//    with no reviews (i.e. .yotpo-empty-state is present).
// ---------------------------------------------------------------------------
(function () {
  function applyEmptyClass() {
    var emptyState = document.querySelector('.product-reviews .yotpo-empty-state');
    if (!emptyState) return false;
    var section = emptyState.closest('.product-reviews');
    if (section) {
      section.classList.add('product-reviews--empty');
    }
    return true;
  }

  if (!applyEmptyClass()) {
    var observer = new MutationObserver(function (_mutations, obs) {
      if (applyEmptyClass()) {
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
